import { Component, Input, ViewEncapsulation } from "@angular/core";
import { LoadAssetsService } from "src/app/load-assets.service";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

@Component({
  selector: "app-header-carousel",
  templateUrl: "./header-carousel.component.html",
  styleUrls: ["./header-carousel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderCarouselComponent {
  timestamp: any = Date.now();
  swiper: any = null;
  @Input() lang: string = "en";
  @Input() slidesStore: any = null;

  constructor(private loadAssetsService: LoadAssetsService) {
    this.loadAssetsService.loadCss(
      "assets/css/swiper-bundle.min.css",
      "carousel-default",
    );
  }

  initializeCarousel() {
    if (typeof window !== "undefined") {
      this.swiper = new Swiper(`.login-swiper-container-${this.timestamp}`, {
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: `.swiper-login-button-next-${this.timestamp}`,
          prevEl: `.swiper-login-button-prev-${this.timestamp}`,
        },
        pagination: {
          el: `.swiper-pagination-${this.timestamp}`,
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
        },
        loop: true,
      });
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeCarousel();
    });
  }

  ngOnInit(): void {}
}
